import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';

import { ALLOW_SOCIAL_CHAT_CREATION } from '../../../constants/chat';
import { ConversationBtn } from '../../ProfileLayout/ConversationBtn';
import FieldsetList from '../../ProfileLayout/FieldSetList';
import { isDesktop } from '../../../utils/mobileHelpers';
import { enhance } from './enhance';
import Avatar from '../../Avatar';

export const PublicProfileDetailsImpl = ({
  profile: { id, avatar, username, isProvider } = {},
  fullName,
  generalInfoFields,
  personalInfoFields,
  addressInfoFields,
}) => (
  <div styleName="content content--profile">
    <div styleName="userAvatar" className="user-profile-avatar">
      <Avatar src={get(avatar, 'thumbMiddle')} children={fullName} size={96} />
    </div>

    <div styleName="info">
      <div
        styleName="userName"
        className={cn('pb3 flex', {
          'items-center justify-between': isDesktop(),
          'flex-column': !isDesktop(),
        })}
      >
        <div>
          <span className="user-profile-name">{fullName}</span>
          <If condition={username}>
            <span
              styleName="colored user-profile-username"
              className="user-profile-username ml2"
            >
              {username}
            </span>
          </If>
        </div>
        {ALLOW_SOCIAL_CHAT_CREATION && <ConversationBtn userId={id} />}
      </div>
      <div styleName="common">
        {/* G E N E R A L     I N F O */}
        <FieldsetList
          fieldSetList={generalInfoFields}
          disabled
          canEdit={false}
        />
      </div>
      <If condition={!isProvider}>
        <div>
          {/* P E R S O N A L   I N F O */}
          <FieldsetList
            fieldSetList={personalInfoFields}
            disabled
            canEdit={false}
          />
          {/* A D D R E S S     I N F O */}
          <FieldsetList
            fieldSetList={addressInfoFields}
            disabled
            canEdit={false}
          />
        </div>
      </If>
    </div>
  </div>
);

PublicProfileDetailsImpl.propTypes = {
  fullName: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  generalInfoFields: PropTypes.array.isRequired,
  personalInfoFields: PropTypes.array.isRequired,
  addressInfoFields: PropTypes.array.isRequired,
};

export const PublicProfileDetails = enhance(PublicProfileDetailsImpl);



// WEBPACK FOOTER //
// ./src/components/PublicProfile/ProfileDetails/index.jsx